import { primarySectionHeaderSx, secondarySectionHeaderSx } from '../../../designTokens';

/**
 * Shared horizontal inset (theme spacing units) for shell window titles, shelf section
 * headers, and execute chrome so text aligns across the top row and side shelf.
 */
export const EXPANDED_PROMPT_SHELL_HORIZONTAL_INSET = 2;

/** Shared inner content width for capability and knowledge builder workspaces. */
export const PRIMARY_WORKSPACE_CONTENT_MAX_PX = 1440;

/** DialogTitle / window title bar for expanded execute shells. */
export const expandedPromptShellTitleSx = {
  flexShrink: 0,
  px: EXPANDED_PROMPT_SHELL_HORIZONTAL_INSET,
  py: { xs: 1.5, sm: 2 },
};

/** Secondary section labels — shelf capability section, etc. */
export const expandedPromptShellSectionTitleSx = {
  ...secondarySectionHeaderSx,
};

/** Prompt/capability detail modal — Description & Knowledge (matches builder major sections). */
export const promptDetailSectionHeaderSx = {
  fontSize: '0.9375rem',
  fontWeight: 600,
  letterSpacing: '-0.01em',
  lineHeight: 1.35,
  color: 'text.primary',
};

/** AI Instructions block title — primary content section. */
export const capabilityInstructionsTitleSx = {
  ...primarySectionHeaderSx,
  fontSize: '1rem',
  fontWeight: 600,
  letterSpacing: 0,
};

/** Scrollable shelf body under section headers. */
export const expandedPromptShelfContentSx = {
  py: 1.5,
  px: EXPANDED_PROMPT_SHELL_HORIZONTAL_INSET,
};

/** Row wrapping a shelf section title + optional add control. */
export const expandedPromptShelfSectionHeaderRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  pl: 0,
  pr: 0,
  mb: 0.5,
  minHeight: 28,
};

/**
 * Letterboxed shell for freestyle, project execute, and prompt execute surfaces.
 * ~15% narrower width; full letterbox height (95vh).
 */
export const expandedPromptShellPaperSx = {
  width: { xs: '100vw', sm: '81vw' },
  height: { xs: '100dvh', sm: '95vh' },
  maxWidth: { xs: '100vw', sm: '81vw' },
  maxHeight: { xs: '100dvh', sm: '95vh' },
  m: { xs: 0, sm: 1 },
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

/**
 * Primary workspace modal — shared by capability and knowledge build/read flows.
 * Keeping one shell size prevents the interface from shifting when users move
 * between creating and reviewing related content.
 */
export const primaryWorkspaceDialogPaperSx = {
  ...expandedPromptShellPaperSx,
  maxWidth: { xs: '100vw', sm: 'min(1600px, 81vw)' },
};

/** Capability and knowledge builder modal. */
export const promptBuilderShellPaperSx = primaryWorkspaceDialogPaperSx;

/** Knowledge read modal. */
export const contextViewDialogPaperSx = primaryWorkspaceDialogPaperSx;

/** Capability read modal. */
export const promptLibraryViewDialogPaperSx = primaryWorkspaceDialogPaperSx;
